import {
  Auth0Provider as Auth0ProviderBase,
  type Auth0ProviderWithConfigOptions as Auth0ProviderBaseProps,
} from '@auth0/auth0-react'
import React from 'react'
import { useNavigate } from 'react-router'

import { exists } from '~/utils'

const authorizationParams: Auth0ProviderBaseProps['authorizationParams'] = {
  redirect_uri: window.location.origin,
}

export type Auth0ProviderProps = React.PropsWithChildren

export const Auth0Provider = ({ children }: Auth0ProviderProps) => {
  const navigate = useNavigate()
  const handleRedirectCallback = React.useCallback<
    EH<Auth0ProviderBaseProps, 'onRedirectCallback'>
  >(
    (appState) => {
      const returnTo = appState?.returnTo
      if (exists(returnTo)) {
        navigate(returnTo, { replace: true })
      }
    },
    [navigate],
  )

  return (
    <Auth0ProviderBase
      authorizationParams={authorizationParams}
      clientId={process.env.AUTH0_CLIENT_ID}
      domain={process.env.AUTH0_DOMAIN}
      onRedirectCallback={handleRedirectCallback}
    >
      {children}
    </Auth0ProviderBase>
  )
}
